import { LinearProgress, linearProgressClasses, styled } from '@mui/material';

export const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  height: 16,
  borderRadius: 4,
  [`&.${linearProgressClasses.root}`]: {
    backgroundColor: theme.palette.primary.main,
  },
}));
